import { pushData } from './dataLayer/index';
import {
  SITE_VISIT_COUNT,
  NEW_SITE_VISIT_COUNT,
  SESSION_VISIT_COUNT,
} from 'constants/cookies';
import { logger } from 'logging';
import { getCookie, setCookie } from './cookie';

function setUpSessionCount() {
  try {
    const sessionCountFromCookie = getCookie(SITE_VISIT_COUNT) as string;
    const sessionCount = parseInt(sessionCountFromCookie, 10);
    const newSessionCount = sessionCount ? sessionCount + 1 : 1;

    pushData({ visitCount: newSessionCount });
    setCookie(SITE_VISIT_COUNT, newSessionCount, 365);
  } catch (err) {
    logger.error(err, 'Error setting session count');
  }
}

export default setUpSessionCount;

export const setUpPdpSessionCount = (isPDPBannerShown: boolean) => {
  // when user lands on pdp its value set to 0 or  depending on the experiment in his he lies
  // when user lands on other than pdp its value set to -1
  // once cookie value is set to 1 in another session it will be increased so that
  // user will see the banner only one time.
  let hasSetVisitCount = Number(getCookie(NEW_SITE_VISIT_COUNT));
  if (!hasSetVisitCount) {
    if (location?.pathname?.indexOf('/p/') < 1) {
      setCookie(NEW_SITE_VISIT_COUNT, -1, 0.02083);
    } else if (isPDPBannerShown) {
      setCookie(NEW_SITE_VISIT_COUNT, 1, 0.02083);
    } else {
      setCookie(NEW_SITE_VISIT_COUNT, 0, 0.02083);
    }
  } else if (hasSetVisitCount > 0) {
    hasSetVisitCount += 1;
    setCookie(NEW_SITE_VISIT_COUNT, hasSetVisitCount, 0.02083);
  }
};

export const setSiteVisitSessionCount = () => {
  try {
    const sessionCountFromStorage = sessionStorage.getItem(
      SESSION_VISIT_COUNT
    ) as string;
    const sessionCount = parseInt(sessionCountFromStorage, 10);
    const newSessionCount = sessionCount ? sessionCount + 1 : 1;

    pushData({ sessionVisitCount: newSessionCount });
    sessionStorage.setItem(SESSION_VISIT_COUNT, newSessionCount);
  } catch (err) {
    logger.error(err, 'Error setting session visit count in storage');
  }
};
